export interface LocationInclude {
  states:       string[];
  cities:       string[];
  state_cities: string[];
}

export interface KeywordRow {
  field: string;
  op:    string;
  text:  string;
}

export interface LocationExclude {
  states?:       string[];
  cities?:       string[];
  state_cities?: string[];
}

// task 446ea38b Slice 1 — how LeopardSpecialtyResolver arrived at the
// specialties.include list, so the UI can tell Steven "AI matched this"
// vs. "no match, broad search" vs. "you set this yourself".
export interface SpecialtyResolution {
  source:      "alias" | "ai" | "miss" | "existing" | "unenriched";
  resolved_at: string;
}

export interface SearchParams {
  locations?:            { include: LocationInclude; exclude: LocationExclude };
  practice_area?:        { include: string[]; exclude: string[]; operator: "OR" | "AND" };
  specialties?:          { include: string[]; exclude: string[]; operator: "OR" | "AND" };
  keyword?:              { rows: KeywordRow[]; operator: "AND" | "OR" };
  candidate_types?:      string[];
  firm_tier?:            number | null;
  law_school_tier?:      number | null;
  jd_year?:              { min: number | null; max: number | null };
  tenure_min?:           number;
  honors?:               string[];
  specialty_resolution?: SpecialtyResolution;
  jd_year_source?:       "ai_widened";
}

export interface LeopardResult {
  id:            number;
  first_name:    string | null;
  last_name:     string | null;
  email:         string;
  firm_name:     string | null;
  firm_title:    string | null;
  jd_year:       number | null;
  location:      string | null;
  law_school:    string | null;
  practice_area: string | null;
  phone:         string | null;
  leopard_link:  string | null;
  linkedin_url:  string | null;
  leopard_id:    string | null;
  dnc_status:    "unchecked" | "clear" | "blocked" | "tentatively_blocked";
}
